import { render, staticRenderFns } from "./MiniWizardStickyCollapsible.vue?vue&type=template&id=c079ff4a&"
import script from "./MiniWizardStickyCollapsible.vue?vue&type=script&lang=js&"
export * from "./MiniWizardStickyCollapsible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports